import axios from 'axios'
import ImageCrud from './ImageCrud.class'
import { cloneDeep, has } from 'lodash'

const baseURL = '/api/company/'

export default class Company {
	/** @constructor
	 * @param {number | Object} init
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = init.hasOwnProperty('id') ? init.id : null
		this.name = init.hasOwnProperty('name') ? init.name : ''
		this.full_name = init.hasOwnProperty('full_name') ? init.full_name : ''
		this.info = init.hasOwnProperty('info') ? init.info : ''
		this.full_info = init.hasOwnProperty('full_info') ? init.full_info : ''
		this.logo = init.hasOwnProperty('logo') ? new ImageCrud(init.logo) : new ImageCrud()
		this.new_logo = null
		this.site_url = has(init, 'site_url') ? init.site_url : null

		this.oldStateStr = this.getStateStr()
	}

	static url = baseURL

	/**
	 * get all company
	 * @param {Object} params
	 * @returns {Promise<{meta: Object, data: Company[]} | null>}
	 */
	static async getAll (params) {
		try {
			const {data} = await axios.get(baseURL, {params})
			if (data) {
				return {
					meta: data.meta,
					data: Array.from(data.data).map(item => new Company(item))
				}
			} else {
				throw Error('Данные компаний не получены')
			}
		} catch (e) {
			console.error(e)
			return null
		}
	}
	/**
	 * get company by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
	/**
	 * get form data
	 * @returns {FormData}
	 */
	get formData () {
		const formData = new FormData()

		formData.append('name', this.name)
		formData.append('full_name', this.full_name || '')
		formData.append('info', this.info || '')
		formData.append('full_info', this.full_info || '')
		formData.append('site_url', this.site_url || '')
		if (this.new_logo) {
			formData.append('logo', this.new_logo)
		}

		return formData
	}
	/**
	 * update company by id
	 * @returns {Promise<boolean>}
	 */
	update () {
		return axios.post(`${baseURL}${this.id}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	/**
	 * create company
	 * @returns {Promise<*>}
	 */
	create () {
		return axios.post(`${baseURL}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	/**
	 * delete news by id
	 * @returns {boolean}
	 */
	async delete () {
		try {
			return await axios.delete(`${baseURL}${this.id}`)
		} catch (e) {
			console.error(e)
			return false
		}
	}

	get hasChange () {
		const str = this.getStateStr()
		if (this.new_logo) {
			return true
		} else	if (str.length !== this.oldStateStr.length) {
			return true
		} else if (str !== this.oldStateStr) {
			return true
		} else {
			return false
		}
	}

	static changeableFields = [
		'name',
		'full_name',
		'info',
		'full_info',
		'site_url'
	]
	// static deleteById (id) {
	// 	return axios.delete(`${baseURL}${id}`)
	// 		.then(res => {
	// 			return res
	// 		})
	// 		.catch(err => {
	// 			console.error(err)
	// 			return false
	// 		})
	// }
	getStateStr () {
		const obj = {}
		Company.changeableFields.forEach(field => {
			obj[field] = this[field]
		})
		return JSON.stringify(obj)
	}

	/**
	 * Клонирует текущий объект и возвращает его клон
	 * @return {Company}
	 */
	clone () {
		const cloneObj = cloneDeep(this)
		// eslint-disable-next-line no-proto
		cloneObj.__proto__ = Company.prototype

		if (this.logo) {
			cloneObj.logo = this.logo.clone()
		}

		return cloneObj
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Company.class.js